module.exports = {"421125100":"清泉镇","421125101":"巴河镇","421125102":"竹瓦镇","421125103":"汪岗镇","421125104":"团陂镇","421125105":"关口镇","421125106":"白莲镇","421125107":"蔡河镇","421125108":"洗马镇","421125109":"丁司垱镇","421125110":"散花镇","421125111":"兰溪镇","421125200":"绿杨乡","421125400":"策湖国家湿地公园管理处","421125401":"三角山旅游度假区管理委员会","421125402":"经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421125.json
// module id = 1901
// module chunks = 0